export const CATEGORIES_TECHNOLOGIES = [
  {
    technology: 'Session, load-balancing, and security cookies',
    category: 'Strictly necessary',
    purpose:
      'Keep the Service available, maintain your session through the estimation flow, and protect against abuse',
    consentRequired: 'No',
    ProviderAndPrivacyTerms: 'Lasoft; Amazon Web Services; Cloudflare',
  },
  {
    technology: 'Preference cookies',
    category: 'Functional',
    purpose:
      'Remember your language choice and your progress or inputs in the estimation flow',
    consentRequired: 'Yes',
    ProviderAndPrivacyTerms: 'Lasoft',
  },
  {
    technology: 'Google Analytics',
    category: 'Analytics',
    purpose: 'Measure how visitors reach and move through the Service',
    consentRequired: 'Yes',
    ProviderAndPrivacyTerms:
      'Google Ireland Limited / Google LLC - Google Privacy Policy',
  },
  {
    technology: 'Hotjar',
    category: 'Behavior analytics',
    purpose: 'Heatmaps and session recordings showing how pages are used',
    consentRequired: 'Yes',
    ProviderAndPrivacyTerms: 'Hotjar Ltd - Hotjar Privacy Policy',
  },
  {
    technology: 'LinkedIn Insight Tag',
    category: 'Marketing and retargeting',
    purpose: 'Measure B2B campaign performance and build retargeting audiences',
    consentRequired: 'Yes',
    ProviderAndPrivacyTerms:
      'LinkedIn Ireland Unlimited Company / LinkedIn Corporation',
  },
  {
    technology: 'Hotjar',
    category: 'Behavior analytics',
    purpose: 'Heatmaps and session recordings',
    consentRequired: 'Yes',
    ProviderAndPrivacyTerms: 'Within the EEA; SCCs for any onward transfer',
  },
  {
    technology: 'LinkedIn',
    category: 'Marketing and retargeting',
    purpose: 'Campaign measurement and retargeting audiences',
    consentRequired: 'Yes',
    ProviderAndPrivacyTerms: 'SCCs; EU-US Data Privacy Framework',
  },
  {
    technology: 'Meta Pixel',
    category: 'Marketing and retargeting',
    purpose:
      'Conversion tracking and audience targeting on Facebook and Instagram',
    consentRequired: 'Yes',
    ProviderAndPrivacyTerms:
      'Meta Platforms Ireland Limited / Meta Platforms, Inc.',
  },
  {
    technology: 'X conversion tracking',
    category: 'Marketing and retargeting',
    purpose: 'Measure the performance of advertising campaigns run on X',
    consentRequired: 'Yes',
    ProviderAndPrivacyTerms:
      'X Corp. (Twitter International Unlimited Company)',
  },
  {
    technology: 'Google Tag Manager',
    category: 'Tag management (not itself analytics or marketing)',
    purpose: 'Deploys and manages the tags listed above; see 5.3',
    consentRequired: 'See 5.3',
    ProviderAndPrivacyTerms: 'Google Ireland Limited / Google LLC',
  },
];

export const RECIPIENTS = [
  {
    recipient: 'Amazon Web Services (including Amazon CloudFront)',
    role: 'Processor',
    receives:
      'Hosting and content delivery for the Service; stores Estimator Inputs and uploaded files',
    location: '',
    transfer:
      'EU region, no transfer / SCCs and EU-US Data Privacy Framework where data leaves the EEA',
  },
  {
    recipient: 'Cloudflare',
    role: 'Processor',
    receives:
      'Content delivery, DNS, and protection against attacks; processes IP addresses and request metadata',
    location: 'EU and US',
    transfer: 'SCCs; EU-US Data Privacy Framework',
  },
  {
    recipient: 'HubSpot',
    role: 'Processor',
    receives:
      'Our CRM; stores your contact details, inquiry, and estimate history to manage the lead and Our correspondence',
    location: 'EU and US',
    transfer: 'SCCs; EU-US Data Privacy Framework',
  },
  {
    recipient: 'Google (Google Workspace, including Gmail)',
    role: 'Processor',
    receives:
      'Business email and productivity infrastructure used to correspond with you',
    location: 'EU and US',
    transfer: 'SCCs; EU-US Data Privacy Framework',
  },
  {
    recipient: 'Google (Google Analytics, Google Tag Manager, Google Ads)',
    role: 'Processor for Analytics and Tag Manager',
    receives: 'Usage measurement and tag deployment; advertising measurement',
    location: 'EU and US',
    transfer: 'SCCs; EU-US Data Privacy Framework',
  },
  {
    recipient: 'Hotjar',
    role: 'Processor for Analytics and Tag Manager',
    receives: 'Heatmaps and session recordings',
    location: 'EEA / Malta',
    transfer: 'Within the EEA; SCCs for any onward transfer',
  },
  {
    recipient: 'LinkedIn',
    role: 'Joint controller for the Insight Tag; independent controller for its own purposes',
    receives: 'Campaign measurement and retargeting audiences',
    location: 'EU and US',
    transfer: 'SCCs; EU-US Data Privacy Framework',
  },
  {
    recipient: 'Meta Platforms',
    role: 'Joint controller for the Pixel; independent controller for its own purposes',
    receives: 'Conversion tracking and audience targeting',
    location: 'EU and US',
    transfer: 'SCCs; EU-US Data Privacy Framework',
  },
  {
    recipient: 'X Corp.',
    role: 'Independent controller for its own purposes',
    receives: 'Advertising conversion tracking',
    location: 'US',
    transfer: 'SCCs',
  },
  {
    recipient: 'Professional advisers (legal, tax, accounting, audit)',
    role: 'Independent controllers',
    receives: 'Advice and statutory audit, where relevant',
    location: 'Poland and, where applicable, third countries',
    transfer: 'Confidentiality agreements; SCCs where applicable',
  },
  {
    recipient: 'Public authorities',
    role: 'Independent controllers',
    receives: 'Where disclosure is required by law',
    location: 'As applicable',
    transfer: 'Statutory basis',
  },
];
